import { uk_labels } from "./uk-lables";
import { uk_labels_ap } from "./uk-lables-ap";

export const getStaticText = (text) => {
    if (typeof text === "undefined") return uk_labels;
    if (typeof uk_labels[text] !== "undefined") return uk_labels[text];
    if (typeof uk_labels_ap[text] !== "undefined") return uk_labels_ap[text];
    return null;
}
